export default __webpack_public_path__ + "static/configure-your-robert-14a83e0d573731286afd14dd3bdabb24.png";